var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.actionComponent)?_c('div',[_c(_vm.actionComponent,{tag:"component",attrs:{"action":_vm.pendingAction},on:{"answered":_vm.answered}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }